import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, computed } from "vue";
import { TextInputProps } from "@/types";
import { useMargins, useVModel } from "@/hooks";


/**
 * A generic text input.
 */
const __default__ = {
  name: "TextInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: undefined },
    hint: { default: undefined },
    hideHint: { type: Boolean },
    type: { default: "text" },
    rows: {},
    label: { default: "" },
    class: { default: "" },
    errorMessage: { type: [String, Boolean], default: "" },
    b: { default: "1" },
    disabled: { type: Boolean },
    dataCy: { default: undefined }
  },
  emits: ["update:modelValue", "enter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = useVModel(props, "modelValue");

const className = useMargins(props, () => [[!!props.class, props.class]]);

const showError = computed(() =>
  props.hideHint
    ? // If the hint is hidden, don't show the error. Undefined will remove the bottom margin for the message.
      undefined
    : // If there is an error message, show it. Either way, the input will have a bottom margin.
      (props.errorMessage && props.errorMessage.length > 0) || false
);

/**
 * Emits an event when enter is clicked.
 */
function handleKeydown(e?: { key: string }) {
  if (e?.key === "Enter") {
    emit("enter");
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    filled: "",
    label: props.label,
    "data-cy": props.dataCy,
    "error-message": props.errorMessage || '',
    error: showError.value,
    class: _normalizeClass(_unref(className)),
    hint: props.hint,
    "hide-hint": props.hideHint,
    type: props.type,
    disable: props.disabled,
    onKeydown: handleKeydown
  }, {
    append: _withCtx(() => [
      _renderSlot(_ctx.$slots, "append")
    ]),
    _: 3
  }, 8, ["modelValue", "label", "data-cy", "error-message", "error", "class", "hint", "hide-hint", "type", "disable"]))
}
}

})